/*********************** Custom JS for Boost AI Search & Discovery  ************************/
// #229190
function buildItemSizes(data) {
  let html = '';
  let variants = data.variants;
  let sizes = [];
  for (let i = 0; i < variants.length; i++) {
    let size = null;
    if (variants[i].merged_options[0].includes('size:')) {
      size = variants[i].merged_options[0].split(':')[1];
    }
    if (typeof (variants[i].merged_options) !== 'undefined' && size !== null) {
      let sizeData = {
        'available': variants[i].available,
        'id': variants[i].id,
        'size': size
      };
      if (!sizes.includes(sizeData)) {
        sizes.push(sizeData);
      }
    }
  }
  if (sizes.length > 0) {
    html += '<ul>';
    for (let j = 0; j < sizes.length; j++) {
      if (sizes[j].available) {
        html += '<li data-id="' + sizes[j].id + '">' + sizes[j].size + '</li>';
      } else {
        html += '<li disabled data-id="' + sizes[j].id + '">' + sizes[j].size + '</li>';
      }
    }
    html += '</ul>';
  }
  return html;
}
// End #229190
// swap product card image order for mens collections (so mens images show first)
// use the theme settings to collect the collection
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    /* Start-Boost-32691 */
    componentRegistry.useComponentPlugin('ProductImage', {
      name: 'Product Image',
      enabled: true,
      apply: () => ({
        props(props, element) {
          try {
            const productData = element?.getParentElm()?.getParams()?.props?.data;

            if (productData) {
              // const menCollects = ['mens-bolt-collection', 'mens-5-stripe-collection', 'mens-ninja-collection', 'mens-sweatshirts', 'mens-hoodies', 'mens-tees'];
              let dataCollectionSwapImage = document.body.getAttribute('data-collection-swap-image');
              if (dataCollectionSwapImage) {
                if (productData.images_info.length > 2) {
                  props.images[0] = productData.images_info[1]['src'];
                  props.images[1] = productData.images_info[0]['src'];
                  // remove second image which is female model
                  props.images[1] = null;
                }
              }
            }
          } catch (e) {
            console.warn(e);
          }

          return props;
        }
      })
    });
  }
])
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Custom Product Item - #229190',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // Extract product data
            const productData = element?.getParentElm()?.getParams()?.props?.data;
            const productDetails = element.getParams().props.product;

            // Build custom HTML for quick add
            const itemSizesHtml = buildItemSizes(productDetails);
            const quickShopButtons = `
                <div class="boost-quickshop">
              <button class="quickshop">Quick Shop</button>
              <button class="addtobag">Add To Bag</button>
                </div>`;
            const customQuickAddHtml = `
                <div class="boost-custom-quickshop">
              ${itemSizesHtml}
              ${quickShopButtons}
                </div>`;

            // Select product items matching the current product ID
            const productItems = document.querySelectorAll(
              `.boost-sd__product-item[data-product-id="${productDetails.id}"]`
            );

            // Define collections to skip
            const skipCollections = ['trucker-hats', 'beanies', 'kids-hats'];

            // Check if the product should skip quick shop customization
            const shouldSkipQuickShop =
              skipCollections.includes(boostSDAppConfig.generalSettings.collection_handle) ||
              productDetails.tags.includes('hide_quick_shop_boost');

            if (!shouldSkipQuickShop) {
              productItems.forEach((item) => {
                // Add quick shop HTML if not already present
                if (!item.querySelector('.boost-quickshop')) {
                  const imageContainer = item.querySelector(
                    '.boost-sd__product-item-grid-view-layout-image'
                  );
                  imageContainer.insertAdjacentHTML('beforeend', customQuickAddHtml);
                }
              });
            }
          } catch (error) {
            console.error('Error in afterRender:', error);
          }
        }
      })
    });
  }
]);

// Start Boost Custom
// #229190
if (jQuery) {
  jQuery(document).on('click', '.boost-custom-quickshop ul li', function () {
    var variantId = jQuery(this).data('id');
    let formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });

  jQuery(document).on('click', '.boost-custom-quickshop .boost-quickshop button.quickshop', function () {
    jQuery(this).closest('.boost-sd__product-item').find('.boost-sd__btn-quick-view').click();
  });

  jQuery(document).on('click', '.boost-custom-quickshop .boost-quickshop button.addtobag', function () {
    jQuery('.boost-custom-quickshop > ul').removeClass('active');
    jQuery(this).closest('.boost-sd__product-item').find('.boost-custom-quickshop > ul').toggleClass('active');
  });
}
// End #229190
// End Boost Custom
